import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { Injectable } from '@angular/core';
import { Utils } from '../static/utils';
import { AiChatService } from '../../ai-chat/services/ai-chat.service';

export type UserConfig = {
  aiEnabled: boolean;
};

@Injectable()
export class AuthService {

  protected isLoggedInSource = new BehaviorSubject<boolean>(false);
  public isLoggedIn$: Observable<boolean>;

  private readonly _userConfigSubject = new BehaviorSubject<UserConfig | null>(null);
  readonly userConfig$: Observable<UserConfig | null> = this._userConfigSubject.asObservable();

  constructor(
    private httpClient: HttpClient,
    protected route: ActivatedRoute,
    private readonly aiChatService: AiChatService
  ) {
    this.verifyParams();
    this.userLoggedIn();
    this.setupUserConfig();
  }

  verifyParams() {
    this.route.queryParams.subscribe((params) => {
        if (params) {
            if (params.loginToken) this.setLocal('loginToken', params.loginToken);
            if (params.userName) this.setLocal('user_name', params.userName);
            if (params.language) this.setLocal('language', params.language);
            if (params.userId) this.setLocal('user_id', params.userId);
            if (params.apiIP) this.setLocal('apiIP', params.apiIP);
        }
    });
  }
  
  userLoggedIn() {
    this.isLoggedInSource.next(!!localStorage.getItem('loginToken'));
    this.isLoggedIn$ = this.isLoggedInSource.asObservable();
  };

  existParams() {
    let params = false;
    this.route.queryParams.subscribe((value) => params = !!value.loginToken);

    return params;
  }

  setLocal = (key, value) => localStorage.setItem(key, value);

  hasTokenLocalStorage() {
    return !!localStorage.getItem('loginToken');
  }

  getToken () {
    return localStorage.getItem('loginToken')
  }

  testConnection(address: string) {
    return this.httpClient.get(address + '/api-is-running');
  }

  setApiIP(apiIP: string) {
    localStorage.setItem('apiIP', apiIP);
  }

  getApiIP(): string {
    return localStorage.getItem('apiIP');
  }

  setLoginState(user) {
    localStorage.setItem('loginToken', user.login_token);
    localStorage.setItem('user_name', user.name);
    localStorage.setItem('user_id', user.id);

    this.isLoggedInSource.next(true);
  }

  getUserId() {
    if(this.hasTokenLocalStorage())
    return localStorage.getItem('user_id');
  }

  setLogoutState() {
    localStorage.removeItem('loginToken');
    localStorage.removeItem('user_name');
    localStorage.removeItem('user_id');
    localStorage.removeItem('EK_user_config');

    this.isLoggedInSource.next(false);
    this._userConfigSubject.next(null);
    this.aiChatService.reset();
  }

  private setupUserConfig() {
    const config = Utils.safeJsonParse<UserConfig>(localStorage.getItem('EK_user_config'));
    if (config) {
      this._userConfigSubject.next(config);
    }
  }

  setUserConfig(config: UserConfig | null) {
    localStorage.setItem('EK_user_config', Utils.safeStringify(config));
    this._userConfigSubject.next(config);
  }

  getUserConfig(): UserConfig | null {
    return this._userConfigSubject.value;
  }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/service/auth.service.ts